module.exports = __webpack_public_path__ + "media/icons/company-www@3x-dcdb8733.svg";